module.exports = __webpack_public_path__ + "static/img/62994220.d72b924c.png";